import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import ja from 'element-plus/es/locale/lang/ja'

export default {
  install(app) {
    app.use(ElementPlus, { locale: ja })
  }
}
